import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useState } from "react";
import { RETURN_REQUEST, PRIVILEGE } from "constants.js";
import { dateTimeFormat, formatAmountWithRupeeSymbol, checkPrivilege } from "common.js";
import { useTranslation } from "react-i18next";
import MDButton from "components/MDButton";
import ConfirmationModelLoad from './ConfirmationModelLoad';

function ReturnSummary(props) {
  const { t } = useTranslation();
  const { setIsLoading } = props;
  const [pageContent, setPageContent] = useState(props.pageContent);
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [confirmReturnId, setConfirmReturnId] = useState(0);
  const adminType = localStorage.getItem("type");

  let returnRequestStatus = pageContent.status == RETURN_REQUEST.REQUESTED ? t('requested') :
    pageContent.status == RETURN_REQUEST.OPEN ? t('open') :
      pageContent.status == RETURN_REQUEST.DECLINED ? t('declined') :
        pageContent.status == RETURN_REQUEST.CLOSED ? t('closed') :
          null;


  const handleConfirmationDialogOpen = () => {
    setConfirmationDialogOpen(true);
  };


  return (
    <>
      <Grid container spacing={0} mt={1}>
        <Grid item sm={6} xs={12} my={1}>
          <Typography sx={{ fontSize: 14 }} component="div">
            <Box className="orderStatusBox">
              <div className="orderStatusBoxLeft">{t('orderedOn')}</div>
              <div className="orderStatusBoxMiddle">:</div>
              <div className="orderStatusBoxRight">
                {dateTimeFormat(pageContent.orderedDate)}
              </div>
            </Box>
          </Typography>
        </Grid>


        <Grid item sm={6} xs={12} my={1}>
          <Typography sx={{ fontSize: 14 }} component="div">
            <Box className="orderStatusBox">
              <div className="orderStatusBoxLeft">{t('orderVendorId')}</div>
              <div className="orderStatusBoxMiddle">:</div>
              <div className="orderStatusBoxRight">
                {pageContent.orderVendorId}
              </div>
            </Box>
          </Typography>
        </Grid>


        <Grid item sm={6} xs={12} my={1}>
          <Typography sx={{ fontSize: 14 }} component="div">
            <Box className="orderStatusBox">
              <div className="orderStatusBoxLeft">{t('returnedOn')}</div>
              <div className="orderStatusBoxMiddle">:</div>
              <div className="orderStatusBoxRight">
                {dateTimeFormat(pageContent.createdAt)}
              </div>
            </Box>
          </Typography>
        </Grid>

        <Grid item sm={6} xs={12} my={1}>
          <Typography sx={{ fontSize: 14 }} component="div">
            <Box className="orderStatusBox">
              <div className="orderStatusBoxLeft">{t('returnStatus')}</div>
              <div className="orderStatusBoxMiddle">:</div>
              <div className="orderStatusBoxRight orderStatusBoxAction">
                {returnRequestStatus}

                {((pageContent.disposed == RETURN_REQUEST.DISPOSED && pageContent.status == RETURN_REQUEST.OPEN && pageContent.refundedStatus == 'approved') && (adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("return", "write")))) ?
                  <>
                    <MDButton className="returnSummeryClose" disableRipple onClick={(event) => { event.preventDefault(); setConfirmReturnId(pageContent.id); handleConfirmationDialogOpen(); }} color="primary">{t("close")}</MDButton>
                    <ConfirmationModelLoad
                      confirmationDialogOpen={confirmationDialogOpen}
                      setConfirmationDialogOpen={setConfirmationDialogOpen}
                      confirmReturnId={confirmReturnId}
                      setConfirmReturnId={setConfirmReturnId}
                      pageContent={pageContent}
                      setPageContent={setPageContent}
                      setIsLoading={setIsLoading}
                    />
                  </> :
                  null}
              </div>

            </Box>
          </Typography>
        </Grid>

        <Grid item sm={6} xs={12} my={1}>
          <Typography sx={{ fontSize: 14 }} component="div">
            <Box className="orderStatusBox">
              <div className="orderStatusBoxLeft">{t('customer')}</div>
              <div className="orderStatusBoxMiddle">:</div>
              <div className="orderStatusBoxRight">
                {pageContent.customerEmail}
              </div>
            </Box>
          </Typography>
        </Grid>



        <Grid container mb={1}>
          <Grid item xs={2}>
            <Typography sx={{ fontSize: 14 }} component="div">{t('returnReason')}</Typography>
          </Grid>
          <Grid item xs={10}>
            <Typography sx={{ fontSize: 14 }} component="div">:<span className='paddingleft20px'>{pageContent.returnReason ? t("shoppify return reason " + pageContent.returnReason) : '-'}</span></Typography>
          </Grid>
        </Grid>

        <Grid container mb={1}>
          <Grid item xs={2}>
            <Typography sx={{ fontSize: 14 }} component="div">{t('customerNote')}</Typography>
          </Grid>
          <Grid item xs={10}>
            <Typography sx={{ fontSize: 14 }} component="div"><span className='collenStyle'>:</span><span className='note'>{pageContent.customerNote ? pageContent.customerNote : '-'}</span></Typography>
          </Grid>
        </Grid>

        {(pageContent.status == RETURN_REQUEST.DECLINED) ?
          <>
            <Grid container mb={1}>
              <Grid item xs={2}>
                <Typography sx={{ fontSize: 14 }} component="div">{t('declineReason')}</Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography sx={{ fontSize: 14 }} component="div">:<span className='paddingleft20px'>{pageContent.declineReason ? t("vendor decline reason " + pageContent.declineReason) : "-"}</span></Typography>
              </Grid>
            </Grid>

            <Grid container mb={1}>
              <Grid item xs={2}>
                <Typography sx={{ fontSize: 14 }} component="div">{t('declineNote')}</Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography sx={{ fontSize: 14 }} component="div"><span className='collenStyle'>:</span><span className='note'>{pageContent.declineNote ? pageContent.declineNote : '-'}</span></Typography>
              </Grid>
            </Grid>
          </>

          :
          null}

        {(pageContent.status == RETURN_REQUEST.OPEN || pageContent.status == RETURN_REQUEST.CLOSED) ?
          <>
            <Grid item sm={6} xs={12} my={1}>
              <Typography sx={{ fontSize: 14 }} component="div">
                <Box className="orderStatusBox">
                  <div className="orderStatusBoxLeft">{t('wayBillNumber')}</div>
                  <div className="orderStatusBoxMiddle">:</div>
                  <div className="orderStatusBoxRight">
                    {pageContent.wayBillNo ? pageContent.wayBillNo : '-'}
                  </div>
                </Box>
              </Typography>
            </Grid>

            <Grid item sm={6} xs={12} my={1}>
              <Typography sx={{ fontSize: 14 }} component="div">
                <Box className="orderStatusBox">
                  <div className="orderStatusBoxLeft">{t('disposedStatus')}</div>
                  <div className="orderStatusBoxMiddle">:</div>
                  <div className="orderStatusBoxRight">
                    {(pageContent.disposed == RETURN_REQUEST.DISPOSED) ? t("disposed") : "-"}
                  </div>
                </Box>
              </Typography>
            </Grid>

            <Grid item sm={6} xs={12} my={1}>
              <Typography sx={{ fontSize: 14 }} component="div">
                <Box className="orderStatusBox">
                  <div className="orderStatusBoxLeft">{t('returnAmount')}</div>
                  <div className="orderStatusBoxMiddle">:</div>
                  <div className="orderStatusBoxRight">
                    {pageContent.returnAmount ? formatAmountWithRupeeSymbol(pageContent.returnAmount) : '-'}
                  </div>
                </Box>
              </Typography>
            </Grid>

            <Grid item sm={6} xs={12} my={1}>
              <Typography sx={{ fontSize: 14 }} component="div">
                <Box className="orderStatusBox">
                  <div className="orderStatusBoxLeft">{t('refundedStatus')}</div>
                  <div className="orderStatusBoxMiddle">:</div>
                  <div className="orderStatusBoxRight">
                    {pageContent.refundedStatus ? t(pageContent.refundedStatus) : '-'}
                  </div>
                </Box>
              </Typography>
            </Grid></>

          :
          null
        }


      </Grid>
    </>
  );
}
export default ReturnSummary;
